import React from 'react';
import Link from "next/link";

const InternalLink = ({ href, children }) => {
  return (
    <Link href={href} className="underline">
      { children }
    </Link>
  );
};

export default InternalLink;
